import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {AIS3_COMMENTS_REQUEST_ND_API_PREFIX} from '../model/constants';
import {IAisCommentsRequestResultTableDtoNd} from '../model/types';

export const fetchAisCommentsRequestTableNd = (params?: any) =>
    performRequest<IAisCommentsRequestResultTableDtoNd[]>({
        url: AIS3_COMMENTS_REQUEST_ND_API_PREFIX,
        method: ERequestType.GET,
        params,
    });

export const fetchAisCommentsRequestRowsTableNd = ({requestId}: IFetchAisCommentsRequestRowsTableParams) =>
    performRequest<IAisCommentsRequestResultTableDtoNd>({
        url: `${AIS3_COMMENTS_REQUEST_ND_API_PREFIX}/${requestId}/`,
        method: ERequestType.GET,
    });

export const postAisCommentsRequestNd = async (data: IPostAisCommentsRequestData) =>
    performRequest<string>({
        url: `${AIS3_COMMENTS_REQUEST_ND_API_PREFIX}/save-comments`,
        method: ERequestType.POST,
        data,
    });

export interface IFetchAisCommentsRequestTableParams {
    length?: number;
    paginationCurrent?: number;
    paginationPageSize?: number;
    search?: string | null;
    sorterField?: string;
    sorterOrder?: 'ascend' | 'descend';
    start?: number;
}

export interface IPostAisCommentsRequestData {
    id: number;
    comment?: string;
}

export interface IFetchAisCommentsRequestRowsTableParams {
    requestId: number;
}
